import { Path } from 'history'
import { useHistory } from 'react-router-dom'
import { isDEV, useClaimant } from '../../../context/col'
import { CaseTypeType } from '../../../models'

export const pathToInit: Path = '/init/:type'
export const pathToInsurance: Path = '/insurance'
export const toInit = ({
  caseType,
  webuserid,
}: {
  caseType: CaseTypeType
  webuserid?: string | null | undefined
}) => (webuserid ? `/init/${caseType}/${webuserid}` : `/init/${caseType}`)

export const pathToRootPage: Path = '/'
export const pathToLeadingPage: Path = './leading-page'
/* TODO zrusit */
export const pathToTrip: Path = '/trip'
export const pathToClaimant: Path = '/claimant'
export const pathToHealthProblem: Path = '/health-problem'
export const pathToCancellation: Path = '/cancellation'
export const pathToCancellationExpenses: Path = '/cancellation-expenses'
export const pathToTreatmentExpenses: Path = '/treatment-expenses'
export const pathToBankAccount: Path = '/other-data'
export const pathToOverview: Path = '/overview'
export const pathToThankYou: Path = '/thank-you'
export const pathToBaggage: Path = '/ba'
export const pathToPersonalAccident: Path = '/accident'
export const pathToLiability: Path = '/liability'
export const pathToTicket: Path = '/ticket'
/* */

// Koncept ==> ColPlProgressContext (== ClaimantContext)
// CaseReportWizardContext
// https://stackoverflow.com/questions/30971395/difference-between-react-component-and-react-element
export interface ColplRouting {
  redirectToLeadingPage: () => void
  goToCaseInit: (caseType: CaseTypeType, webUserId?: string | null) => void
  goToCaseRefresh: (caseType?: CaseTypeType) => void
  goToRoute: (path: string) => void
  goToCasePage: (caseType: CaseTypeType, path: string) => void
}

export function useColplRouting(): ColplRouting {
  const history = useHistory()
  const caseContext = useClaimant().state
  return {
    /* go to leading page */
    redirectToLeadingPage: function () {
      isDEV
        ? history.push(pathToRootPage)
        : (window.location.href = pathToLeadingPage)
    },

    /* general transition */
    goToRoute: function (path: string) {
      return history.push(path)
    },

    goToCaseInit: function (caseType: CaseTypeType, webUserId?: string | null) {
      return history.push(toInit({ caseType: caseType, webuserid: webUserId }))
    },

    goToCaseRefresh: function (caseType?: CaseTypeType) {
      // ++ TODO prenos locale
      const caseType_fin = caseType ?? caseContext.caseType
      if (caseType_fin == null) {
        // caseType neni zadan, ani nelze odvodit ze stavu!!!
        return this.redirectToLeadingPage()
      } else {
        return history.push(
          toInit({ caseType: caseType_fin, webuserid: caseContext.webUserId })
        )
      }
    },

    /* general transition between pages of the case type */
    goToCasePage: function (caseType: CaseTypeType, path: string) {
      return history.push(`/${caseType}/${path}`)
    },
  }
}
